/* eslint-disable react/no-array-index-key */

import styled from 'styled-components';
import { ColorNeutralBlack, ColorNordicGrey3, Spacing8, Spacing16 } from 'autogen/design-tokens/tokens';
import { MediaItemDiscriminator, type onPaginate } from '../shared/types';

const Container = styled.div`
    display: inline-grid;
    grid-auto-flow: column;
    gap: ${Spacing8};
    padding: ${Spacing8} ${Spacing16};
`;

const Dot = styled.span<{ isActive: boolean }>`
    border-radius: 50%;
    display: flex;
    width: 8px;
    height: 8px;
    background-color: ${({ isActive }) => (isActive ? ColorNeutralBlack : ColorNordicGrey3)};
    cursor: pointer;
`;

const Play = styled.span<{ isActive: boolean }>`
    display: block;
    box-sizing: border-box;
    width: 0;
    height: 8px;
    border-color: ${({ isActive }) =>
        isActive
            ? `transparent transparent transparent ${ColorNeutralBlack}`
            : `transparent transparent transparent ${ColorNordicGrey3}`};
    border-style: solid;
    border-width: 6px 0 6px 12px;
    cursor: pointer;
`;

export default function GalleryPagination({
    items,
    activeIndex,
    onPaginate,
    ...restProps
}: {
    items: any;
    activeIndex: number;
    onPaginate: onPaginate;
}) {
    return (
        <Container {...restProps}>
            {items.map((item, index) =>
                MediaItemDiscriminator(
                    item,
                    () => (
                        <Dot
                            isActive={activeIndex === index}
                            onClick={() => onPaginate(index, item.type)}
                            key={index}
                        />
                    ),
                    () => (
                        <Play
                            isActive={activeIndex === index}
                            onClick={() => onPaginate(index, item.type)}
                            key={index}
                        />
                    ),
                    () => (
                        <Play
                            isActive={activeIndex === index}
                            onClick={() => onPaginate(index, item.type)}
                            key={index}
                        />
                    ),
                    () => (
                        <Dot
                            isActive={activeIndex === index}
                            onClick={() => onPaginate(index, item.type)}
                            key={index}
                        />
                    ),
                    () => (
                        <Dot
                            isActive={activeIndex === index}
                            onClick={() => onPaginate(index, item.type)}
                            key={index}
                        />
                    )
                )
            )}
        </Container>
    );
}
